window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.prewagerPonudaRepo = function () {
    var url= 'api/prewagerponuda';

    var remove = function (ponudaId) {
        return fetch(url, {
            method: 'DELETE',
            credentials: repos.base.credentials,
            headers: repos.base.headers(),
            body: JSON.stringify(ponudaId)
        })
            .then(casino.repos.base.checkResponse)
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        remove: remove
    }
}();